export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-100">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <span className="text-2xl font-heading font-bold text-primary-400 whitespace-nowrap">
              牛牛影视
            </span>
            <p className="mt-4 text-sm text-background-300 leading-relaxed">
              牛牛影视聚合海量电影、电视剧、综艺节目，覆盖牛牛电影大全与牛牛剧集，支持高清不缓冲在线观看，每日更新最新影视资源，一站式满足追剧观影需求。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">快速导航</h3>
            <nav className="flex flex-col gap-2.5">
              {[
                { label: '热播榜单', href: '#ranking' },
                { label: '精选推荐', href: '#cards' },
                { label: '精彩预告', href: '#media' },
                { label: '焦点专题', href: '#carousel' },
                { label: '最新更新', href: '#updates' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">内容分类</h3>
            <nav className="flex flex-col gap-2.5">
              {[
                { label: '动作电影', href: '#index' },
                { label: '国产剧集', href: '#index' },
                { label: '海外剧集', href: '#index' },
                { label: '热门综艺', href: '#index' },
                { label: '动漫番剧', href: '#index' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">合作伙伴</h3>
            <p className="text-sm text-background-400 leading-relaxed">
              携手优质内容方，共建健康影视生态。合作洽谈请联系客服邮箱。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-700/40 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} 牛牛影视. 本站内容仅供学习交流，版权归原作者所有。
          </p>
          <div className="flex items-center gap-4 text-background-400">
            <span className="text-xs">关注我们</span>
            <a href="#contact" className="hover:text-primary-400 transition-colors cursor-pointer">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#contact" className="hover:text-primary-400 transition-colors cursor-pointer">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#contact" className="hover:text-primary-400 transition-colors cursor-pointer">
              <i className="ri-bilibili-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}